import { localStorageColorSchemeManager, MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { ErrorBoundary } from './components/ErrorBoundary';
import { Starfield } from './components/Starfield';
import { moonTheme } from './theme/moonTheme';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import './styles/global.css';

export default function App() {
  const colorSchemeManager = localStorageColorSchemeManager({ key: 'luna-color-scheme' });

  return (
    <MantineProvider
      theme={moonTheme}
      defaultColorScheme="auto"
      colorSchemeManager={colorSchemeManager}
    >
      <Starfield />
      <Notifications position="top-right" />
      <ErrorBoundary>
        <RouterProvider router={router} />
      </ErrorBoundary>
    </MantineProvider>
  );
}
